<template>
  <div class="row  py-2" :class="{'active': reason.selected}" @click="$emit('selectReason', reason)">
    <div class="col-1">
      <i class="fa fa-align-justify handle"  :class="reason.selected  ? 'blue' : ' '"></i>
<!--      <template v-if="reason.selected"><i class="fad fa-chevron-right active-icon ml-3"/></template>-->

    </div>
<!--    <div class="col-1">-->
<!--       <template v-if="reason.selected"><i class="fad fa-chevron-right active-icon"/></template>-->
<!--    </div>-->
    <div class="col-3" v-if="level === 1 ">

      <label for="type-planned">Type</label>
      <select name="type-planned" class="form-control" id="type-planned" v-model="reason.reasonType">
        <option value="out-planned">{{ $t('reasonTrees.plannedTypes.out-planned') }}</option>
        <option value="unplanned">{{ $t('reasonTrees.plannedTypes.unplanned') }}</option>
        <option value="planned">{{ $t('reasonTrees.plannedTypes.planned') }}</option>
      </select>
      <!--      <div class="custom-control custom-checkbox  ">-->
      <!--        <input v-model="reason.planned"-->
      <!--               :value="true"-->
      <!--               :disabled="!reason.editing"-->
      <!--               type="checkbox"-->
      <!--               :id="'planned' + uid"-->
      <!--               class="custom-control-input"-->
      <!--        >-->
      <!--        <label class="custom-control-label" :for="'planned' + uid">-->
      <!--          <span>Planned</span>-->
      <!--        </label>-->
      <!--      </div>-->
    </div>
     <div class="col-2" v-if="( (level == 2  && reason.children.length <= 0) || level == 3  ) && rootType === 'planned'">
      <label for="reason-norm">Norm <small class="text-right">in minutes</small></label>
      <input type="number" id="reason-norm" class="form-control" min=1 v-model.number="reason.norm">
    </div>
    <div class="col" style="cursor:pointer">
      <!--      <template v-if="!reason.editing">-->
      <!--        <p @click="$emit('selectReason', reason)">-->
      <!--          {{ reason.name }}-->
      <!--        </p>-->
      <!--      </template>-->
      <template>
        <label for="reason-name">Reason</label>
        <input type="text" id="reason-name" class="form-control" v-model="reason.name"
               @keyup.enter="reason.editing = false"
        >
      </template>
    </div>
    <div class="col-1">
      <!--      <i class="fad fa-check text-success mr-3" v-if="reason.editing" @click="reason.editing = false"/>-->
      <!--      <i class="fad fa-edit mr-3" v-if="!reason.editing" @click="reason.editing = !reason.editing"/>-->
      <i class="fad fa-trash-alt text-danger" style="cursor:pointer" @click="$emit('deleteReason', reason)"/>
    </div>
  </div>
</template>

<script>
//@vuese
//@group ReasonTrees
//Draggable items for the reason tree levels
export default {
  name: 'DraggableReason',
  props: {
    //@vuese
    // Reason object
    showPlanned: {},
    rootType:{},
    allReasons: {},
    reason: {
      //@vuese
      type: Object,
      required: true
    },
    level: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      uid: this._uid
    };
  },
  watch: {
    'reason.norm': function (newV) {
     this.reason.normInMs = newV * 1000 * 60
    },
    'reason.reasonType': function (newV, oldV) {
      this.reason.planned = newV === 'out-planned' ? true : false;
    },
    'reason.name': function (newV, oldV) {
      if (_.size(_.filter(this.allReasons, { 'name': newV})) > 1) {
        this.reason.name = oldV;
        this.swalError(this.$root.$t('reasonTrees.noUniqueReason.swal'));
      }
    }
  },
  created() {
    if (this.reason && this.level === 1 && !this.reason.reasonType) {
      this.reason.reasonType = 'out-planned'
      this.reason.planned = true
    }
  }
};
</script>


<style lang="scss" scoped>
.handle{
  cursor:grab;
  line-height:100px;
}
.row:hover {
  background: #fcfcfc;
}

.row .active {
  //background: #bbd3d9;isc
}

.fa-trash-alt, .fa-chevron-right {
  margin-top: 30px;
  line-height: 45px;

}

.blue , i.active-icon {
  width: 15px;
  text-align: left;
  color: #00c9ff;
}
</style>